import ComplicationSelector from '@ls/grouping-complication-selector';
import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {setDefinition as setSecurityAttributesDefinition} from 'state/securityAttributes/actions';
import SecurityAttributeDefinition from 'state/securityAttributes/SecurityAttributeDefinition';
import {selectDefinitions} from 'state/securityAttributes/selectors';
import SelectionState from 'state/selections/SelectionState';
import SecurityAttributesSelectorComplication from './SecurityAttributesSelectorComplication';

const SecurityAttributesSelector = (props) => {
  const dispatch = useDispatch();
  const definitions = useSelector(selectDefinitions(SelectionState.UNCOMMITTED));
  const setDefinition = useCallback(
    (idx, definitions) => dispatch(setSecurityAttributesDefinition(idx, definitions)),
    [dispatch],
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={SecurityAttributeDefinition.getDefault}
      ComplicationComponent={SecurityAttributesSelectorComplication}
      btnTitle={'Security Attributes'}
      addMoreText={'Security Attribute'}
    />
  );
};

export default SecurityAttributesSelector;
